export const sleep = (t = 1000) => new Promise((resolve) => setTimeout(resolve, t));

export const IS_DEV_ENV = location.origin.match(/localhost|127.0.0.1/gi);

export const IS_STAGE_ENV = process.env.VUE_APP_APIURL && process.env.VUE_APP_APIURL.includes('stage');

export const PS_API_TOKEN = 'a00981e1539234aa648b07c94196eb5b8bece497b41e816b02fbb906e8e5791758615be71dfcba89';

export const getPortalFromPath = (path) => {
  if (path.startsWith('/admin')) {
    return 'admin';
  } else if (path.startsWith('/supplier') && !path.startsWith('/suppliers')) {
    return 'supplier';
  } else if (path.startsWith('/art') || path.startsWith('/art-proofs')) {
    return 'art';
  } else if (path.startsWith('/promostandards')) {
    return 'promostandards';
  } else {
    return 'app';
  }
};

